import React, { useEffect, useState } from 'react'
import { Button, Card, Input, Table, message } from 'antd'
import moment from 'moment'
import { errorMessage, fetchVouchers } from './api'
import { BASE_PATH, hasPermission } from './helpers'

const PAGE_SIZE = 10

const AcvList = ({ history, authUser }) => {
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [acvNo, setAcvNo] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    fetchVouchers({ limit: PAGE_SIZE, offset: (page - 1) * PAGE_SIZE, acvNo })
      .then((res) => { setData(res.data || []); setCount(res.count || 0) })
      .catch((e) => message.error(errorMessage(e, 'Failed to load vouchers')))
      .finally(() => setLoading(false))
  }, [page, acvNo])

  const columns = [
    { title: 'ACV No', dataIndex: 'acvNo', key: 'acvNo' },
    { title: 'Date', dataIndex: 'date', key: 'date', render: (v) => v && moment(v).format('DD-MM-YYYY HH:mm') },
    { title: 'Location', key: 'location', render: (r) => (r.location && r.location.name) || '' },
    { title: 'Sub Location', key: 'client', render: (r) => (r.client && r.client.name) || '' },
    { title: 'Assets', key: 'count', render: (r) => (r.assetConditions || []).length },
    { title: 'Created By', key: 'createdBy', render: (r) => (r.createdBy && r.createdBy.name) || '' },
    { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt', render: (v) => v && moment(v).format('DD-MM-YYYY HH:mm') },
    {
      title: 'Action',
      key: 'action',
      render: (r) => <Button type='primary' size='small' onClick={() => history.push(`${BASE_PATH}/view/${r._id}`)}>View</Button>
    }
  ]

  return (
    <Card
      className='gx-card-metrics'
      title={
        <div className='acv-title'>
          <span>Asset Condition Vouchers</span>
          {hasPermission(authUser, 'c') &&
            <Button type='primary' icon='plus' size='small' onClick={() => history.push(`${BASE_PATH}/add`)}>Create</Button>}
        </div>
      }
    >
      <Input.Search
        allowClear
        placeholder='Search ACV No'
        className='acv-search'
        onSearch={(value) => { setPage(1); setAcvNo((value || '').trim()) }}
      />
      <Table
        size='small'
        rowKey='_id'
        loading={loading}
        columns={columns}
        dataSource={data}
        scroll={{ x: true }}
        pagination={{ current: page, pageSize: PAGE_SIZE, total: count, onChange: setPage }}
      />
    </Card>
  )
}

export default AcvList
